import { render } from "./Tarifario_TarifaAseg.vue?vue&type=template&id=6142f4ed"
import script from "./Tarifario_TarifaAseg.vue?vue&type=script&lang=js"
export * from "./Tarifario_TarifaAseg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__